import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import * as sweetalert from 'sweetalert';
import { Sort } from '@angular/material';
import { UUID } from 'angular2-uuid';
import { DomSanitizer } from '@angular/platform-browser';
//grid
import { AgGridNg2 } from 'ag-grid-angular';
import { saveAs as importedSaveAs } from "file-saver";

import { GlobalsService } from '../services/globals.service';
import { ViajeService } from '../services/viaje.service';
import { UsuarioService } from '../services/usuario.service';

import { ViajeContenedor } from '../Models/ViajeContenedor';
import { VisitaTarea } from '../Models/VisitaTarea';
import { Usuario } from '../Models/Usuario';
import { GeneradorTemplateService } from '../services/generador-template.service';
import { UtilesService } from '../services/utiles.service';

@Component({
  selector: 'app-reporte-viaje-contenedor',
  templateUrl: './reporte-viaje-contenedor.component.html',
  styleUrls: ['./reporte-viaje-contenedor.component.css']
})
export class ReporteViajeContenedorComponent implements OnInit {

  public reporteContenedor: ViajeContenedor = new ViajeContenedor();
  public reporteContenedores: ViajeContenedor[];

  public visitaTarea: VisitaTarea = new VisitaTarea();

  public usuario: Usuario = new Usuario();


  constructor(private globalServices: GlobalsService, private viajeService: ViajeService, private usuarioService: UsuarioService,
    private utilesService:UtilesService , private generadorTemplate: GeneradorTemplateService) { }

  ngOnInit() {
  }


  CargarReporteContenedor() {
    try {

      var etiquetaContenedor = this.visitaTarea.etiquetaContenedor;
      this.viajeService.ObtenerViajeContenedor(this.globalServices.ObtenerCompania(), etiquetaContenedor).subscribe(
        data => {
          this.reporteContenedor = data;

          if( this.reporteContenedor===null){
            swal("Etiqueta contenedor no existe", "", "error");
              return;
          }

          this.CargarUsuario(this.reporteContenedor.viaje.idUsuario);
        
        },
        err => {
          console.clear();
          console.log(err._body);

        });

    } catch (error) {
      console.log("CargarReporteContenedor error: " + error);
    }
  }



  CargarUsuario(idUsuario: string) {
    try {

     
      this.usuarioService.ObtenerUsuario(this.globalServices.ObtenerCompania(), idUsuario).subscribe(
        data => {
          this.usuario = data;

        
        },
        err => {
          console.clear();
          console.log(err._body);

        });

    } catch (error) {
      console.log("CargarUsuario error: " + error);
    }
  }




/**
 * Metodo que descarga el reporte
 */
DescargarReporte() {
  var etiquetaContenedor = this.visitaTarea.etiquetaContenedor;
  if( this.reporteContenedor===null){
    swal("Etiqueta contenedor no se puede generar el reporte", "", "error");
      return;
  }
    //nombre que va a tener el archivo
    var nombre =  "Reporte Etiqueta Contenedor " + this.visitaTarea.etiquetaContenedor;
    var archivo = this.utilesService.getURLReportes() + nombre + ".pdf" ;
  
    //Genera el arciho PDF en la api
    this.generadorTemplate.ReporteEtiquetaContenedor(this.globalServices.ObtenerCompania(), this.visitaTarea.etiquetaContenedor, nombre ).subscribe(
      (res) => {
       
        if(res.tipoResultado==="ERROR"){
          swal("Error, "+ res.mensaje, "", "error");
            return
        }
     
        var resultado = 'data:application/pdf;base64,' + res.objetoResultado;
        var fileName = "Reporte Contenedor.pdf";

        importedSaveAs(resultado, fileName);
  
      }
    )
  }

}
